import { render, staticRenderFns } from "./special_one_yuan.vue?vue&type=template&id=5f340ad0&scoped=true&"
import script from "./special_one_yuan.vue?vue&type=script&lang=js&"
export * from "./special_one_yuan.vue?vue&type=script&lang=js&"
import style0 from "./special_one_yuan.vue?vue&type=style&index=0&id=5f340ad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f340ad0",
  null
  
)

export default component.exports